import { motion } from "framer-motion";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const barData = [
  { name: "Seg", value: 420, fill: "#2563EB" },
  { name: "Ter", value: 380, fill: "#2563EB" },
  { name: "Qua", value: 520, fill: "#2563EB" },
  { name: "Qui", value: 490, fill: "#2563EB" },
  { name: "Sex", value: 610, fill: "#2563EB" },
  { name: "Sáb", value: 320, fill: "#2563EB" },
  { name: "Dom", value: 280, fill: "#2563EB" },
];

const pieData = [
  { name: "WhatsApp", value: 45, color: "#22C55E" },
  { name: "Instagram", value: 25, color: "#E4405F" },
  { name: "Facebook", value: 18, color: "#1877F2" },
  { name: "Chat Widget", value: 12, color: "#2563EB" },
];

export function ConversationsChart() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-semibold text-[#0F172A]">Conversas Ativas</h3>
          <p className="text-sm text-[#64748B]">Últimos 7 dias</p>
        </div>
        <div className="flex gap-6">
          <div>
            <p className="text-2xl font-bold text-[#0F172A]">497</p>
            <p className="text-xs text-[#64748B]">Atendimentos</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-[#2563EB]">3,582</p>
            <p className="text-xs text-[#64748B]">Mensagens</p>
          </div>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={barData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748B", fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748B", fontSize: 12 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          />
          <Bar dataKey="value" fill="#2563EB" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </motion.div>
  );
}

export function ChannelDonutChart() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <h3 className="text-lg font-semibold text-[#0F172A] mb-4">Canais</h3>

      <div className="flex items-center justify-center">
        <div className="relative">
          <ResponsiveContainer width={180} height={180}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={80}
                paddingAngle={4}
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <p className="text-2xl font-bold text-[#0F172A]">43.2%</p>
            <p className="text-xs text-[#64748B]">WhatsApp</p>
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="mt-4 space-y-2">
        {pieData.map((item) => (
          <div key={item.name} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span
                className="h-3 w-3 rounded-full"
                style={{ backgroundColor: item.color }}
              />
              <span className="text-sm text-[#64748B]">{item.name}</span>
            </div>
            <span className="text-sm font-semibold text-[#0F172A]">
              {item.value}%
            </span>
          </div>
        ))}
      </div>
    </motion.div>
  );
}

const slaData = [
  { name: "Seg", value: 95, color: "#22C55E" },
  { name: "Ter", value: 92, color: "#22C55E" },
  { name: "Qua", value: 78, color: "#EF4444" },
  { name: "Qui", value: 98, color: "#22C55E" },
  { name: "Sex", value: 96, color: "#22C55E" },
  { name: "Sáb", value: 89, color: "#FACC15" },
  { name: "Dom", value: 94, color: "#22C55E" },
];

export function SLAChart() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
      className="rounded-[14px] bg-white p-6 shadow-sm border border-[#E2E8F0]"
    >
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-lg font-semibold text-[#0F172A]">Performance SLA</h3>
        <span className="text-sm text-[#64748B]">Meta: 90%</span>
      </div>

      <ResponsiveContainer width="100%" height={140}>
        <BarChart data={slaData}>
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#64748B", fontSize: 11 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #E2E8F0",
              borderRadius: "10px",
            }}
          />
          <Bar
            dataKey="value"
            radius={[4, 4, 0, 0]}
          >
            {slaData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </motion.div>
  );
}